import { AlertCircle,  Clock, Folder, Home, Star, Trash2, User, UserCheck, Calendar, File, DollarSign, Search, Minus, Bell, TrendingUp} from "react-feather";
import { FaChalkboardTeacher } from "react-icons/fa";
import { AiOutlineTransaction } from "react-icons/ai";
import { TfiWallet } from "react-icons/tfi";
import { FaWpforms } from "react-icons/fa";
import { GrHistory } from "react-icons/gr";
import { MdPayment } from "react-icons/md";
import { MdOutlineBookmarks } from "react-icons/md";
import { LiaCertificateSolid } from "react-icons/lia";
import { RM_TASKS_ENABLED } from "../../../../Tasks/tasksApi";

export const sideButtons = [
  {
    className: "light",
    icon: <User/>,
    title: "Profile",
  },
  {
    className: "light",
    icon: <Calendar/>,
    title: "Calendar",
  },
 
  {
    className: "light",
    icon: <Clock/>,
    title: "Call History",
  },
  {
    className: "light",
    icon: <GrHistory />,
    title: "Student History",
  },
  {
    className: "light",
    icon: <GrHistory />,
    title: "Renewal Info",
  },
  // Only when the RM tool is switched on — it's the source of both.
  ...(RM_TASKS_ENABLED
    ? [
        {
          className: "light",
          icon: <TrendingUp />,
          title: "Journey Summary",
        },
        {
          className: "light",
          icon: <UserCheck />,
          title: "Relationship Manager",
        },
        {
          className: "light",
          icon: <AlertCircle />,
          title: "Tasks",
        },
      ]
    : []),
  {
    className: "light",
    icon: <LiaCertificateSolid />,
    title: "Certificates",
  },
  {
    className: "light",
    icon: <Search/>,
    title: "Find Teacher",  
  },
  

  {
    className: "light",
    icon: <Calendar/>,
    title: "Class Details",
  },
  // {
  //   className: "light",
  //   icon: <User/>,
  //   title: "Profile",
  // },


  {
    className: "light",
    icon: <FaChalkboardTeacher size={20}/>,
    title: "Teacher Change",
  },
  {
    className: "light",
    icon: <MdOutlineBookmarks />,
    title: "Complete Level",
  },
  {
    className: "light",
    icon: <MdOutlineBookmarks />,
    title: "Lessons",
  },
 
  {
    className: "light",
    icon: <AiOutlineTransaction />,
    title: "Course Change",
  },
  {
    className: "light",
    icon: <MdPayment/>,
    title: "Payment Link",
  },
  {
    className: "light",
    icon: <MdPayment/>,
    title: "Split Payment",
  },
  {
    className: "light",
    icon: <DollarSign />,
    title: "Capture Manual Payment",
  },
  {
    className: "light",
    icon: <DollarSign />,
    title: "Course Extension",
  },
  {
    className: "light",
    icon: <AiOutlineTransaction />,
    title: "Transaction List",
  },
 
  // {
  //   className: "light",
  //   icon: <Trash2 />,
  //   title: "Chatbot",
  // },
  {
    className: "light",
    icon: <TfiWallet />,
    title: "Wallet Details",
  },
  {
    className: "light",
    icon: <FaWpforms />,
    title: "Notes",
  },
  
  {
    className: "light",
    icon: <GrHistory />,
    title: "Class History",
  },
  {
    className: "light",
    icon: <FaWpforms />,
    title: "AE Form",
  },
  {
    className: "light",
    icon: <FaWpforms />,
    title: "KYS Form",
  },



 


];




